import { Navigate, Route, Routes } from 'react-router-dom';
import SettingsLayout from './settings-layout';
import { useAuthState } from 'core/providers/AuthProvider';
import { SettingsOptions } from 'core/config/settings-options';

const SettingsRouting = () => {
  const { userRoles } = useAuthState();
  const allowedRoute = SettingsOptions.find((option) => option.roles.some((role) => userRoles?.includes(role)));

  return (
    <Routes>
      <Route element={<SettingsLayout />}>
        {SettingsOptions.map((route) => (
          <Route key={route.route} path={`${route.route}/*`} element={route.element} />
        ))}
      </Route>
      <Route path='' element={<Navigate replace to={allowedRoute?.route || 'users'} />} />
      <Route path='*' element={<Navigate replace to={allowedRoute?.route || 'users'} />} />
    </Routes>
  );
};

export default SettingsRouting;
